// src/components/auth/ProtectedRoute.jsx
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';

const ProtectedRoute = ({ children }) => {
  const storedUser = localStorage.getItem('user');

  if (!storedUser) {
    // Si no hay usuario, redirige al login
    return <Navigate to="/loginVpStore" replace />;
  }

  return children;
};

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ProtectedRoute;
